module.exports = __webpack_public_path__ + "static/media/5.18_preview.cfff4035.png";